import { render, staticRenderFns } from "./assign-edit.vue?vue&type=template&id=0e497a86&scoped=true&"
import script from "./assign-edit.vue?vue&type=script&lang=js&"
export * from "./assign-edit.vue?vue&type=script&lang=js&"
import style0 from "./assign-edit.vue?vue&type=style&index=0&id=0e497a86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e497a86",
  null
  
)

export default component.exports